<template>
  <div class="home">
    <SignUpPage />
  </div>
</template>

<script>
import SignUpPage from '../components/elements/pages/SignUpPage.vue'
export default {
  name: 'SignUp',
  metaInfo: {
    title: 'Sign Up'
  },
  components: {
    SignUpPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
